import alertState from 'optinmonster-js-library/src/vue/campaigns/store/alerts/state';
import actions from './actions';
import mutations from './mutations';

export default {
	namespaced: true,
	actions,
	getters: {
		count: (state) => state.notifications.length,
		has: (state, getters) => 0 < getters.count,
	},
	mutations,
	state: {
		...alertState,
		enabled: true,
		set: false,
		notifications: [],
		queue: [],
	},
};
